import {
    LOWER_PERMANENT,
    LOWER_PRIMARY,
    UPPER_PERMANENT,
    UPPER_PRIMARY,
    formatTeeth,
    type GridTooth
} from './toothNumbering';

type Cell = GridTooth | null;

function padPrimary(teeth: readonly GridTooth[]): Cell[] {
    return [null, null, null, ...teeth, null, null, null];
}

const MIDLINE_INDEX = 7;

// A thumbnail of the tooth grid: which teeth a notification ignores, readable at a glance.
export function ToothMiniChart({ teeth }: { teeth: readonly string[] }) {
    const selected = new Set(teeth);
    const row = (cells: readonly Cell[], primary = false) => (
        <div className="flex gap-px">
            {cells.map((tooth, index) => (
                <span
                    key={index}
                    className={`h-[5px] w-[5px] ${primary ? 'rounded-full' : 'rounded-[1px]'} ${
                        tooth === null
                            ? ''
                            : selected.has(tooth.iso)
                              ? 'bg-[#007E87]'
                              : 'bg-gray-200'
                    } ${index === MIDLINE_INDEX ? 'mr-[3px]' : ''}`}
                />
            ))}
        </div>
    );
    return (
        <div className="flex shrink-0 flex-col gap-px" title={formatTeeth(teeth)} aria-hidden>
            {row(UPPER_PERMANENT)}
            {row(padPrimary(UPPER_PRIMARY), true)}
            <div className="h-[2px]" />
            {row(padPrimary(LOWER_PRIMARY), true)}
            {row(LOWER_PERMANENT)}
        </div>
    );
}
